export const pueblosPuertoRico = [
  'Adjuntas', 'Aguada', 'Aguadilla', 'Aguas Buenas', 'Aibonito', 'Añasco', 'Arecibo', 'Arroyo',
  'Barceloneta', 'Barranquitas', 'Bayamón', 'Cabo Rojo', 'Caguas', 'Camuy', 'Canóvanas', 'Carolina',
  'Cataño', 'Cayey', 'Ceiba', 'Ciales', 'Cidra', 'Coamo', 'Comerío', 'Corozal', 'Culebra',
  'Dorado', 'Fajardo', 'Florida', 'Guánica', 'Guayama', 'Guayanilla', 'Guaynabo', 'Gurabo',
  'Hatillo', 'Hormigueros', 'Humacao', 'Isabela', 'Jayuya', 'Juana Díaz', 'Juncos', 'Lajas',
  'Lares', 'Las Marías', 'Las Piedras', 'Loíza', 'Luquillo', 'Manatí', 'Maricao', 'Maunabo',
  'Mayagüez', 'Moca', 'Morovis', 'Naguabo', 'Naranjito', 'Orocovis', 'Patillas', 'Peñuelas',
  'Ponce', 'Quebradillas', 'Rincón', 'Río Grande', 'Sabana Grande', 'Salinas', 'San Germán',
  'San Juan', 'San Lorenzo', 'San Sebastián', 'Santa Isabel', 'Toa Alta', 'Toa Baja', 'Trujillo Alto',
  'Utuado', 'Vega Alta', 'Vega Baja', 'Vieques', 'Villalba', 'Yabucoa', 'Yauco'
];

export const categorias = [
  { id: 'hogar', nombre: 'Hogar y Enseres (Neveras, estufas, muebles)', icon: 'ri-home-4-line' },
  { id: 'tecnologia', nombre: 'Tecnología y Celulares', icon: 'ri-smartphone-line' },
  { id: 'autos', nombre: 'Autos y Accesorios', icon: 'ri-car-line' },
  { id: 'herramientas', nombre: 'Herramientas y Construcción', icon: 'ri-tools-line' },
  { id: 'moda', nombre: 'Moda y Belleza', icon: 'ri-shirt-line' },
  { id: 'deportes', nombre: 'Deportes y Playa', icon: 'ri-basketball-line' },
  { id: 'bienes_raices', nombre: 'Bienes Raíces', icon: 'ri-building-2-line' },
];